import React from 'react';

const StatCard = ({
  icon,
  iconColor = 'primary',
  color,
  value,
  label,
  change,
  changeType = 'positive',
  trend,
  trendLabel,
}) => {
  const iconClass = color || iconColor;
  const trendValue = trend !== undefined && trend !== null ? trend : change;
  const trendType = trend !== undefined
    ? (typeof trend === 'number' ? (trend >= 0 ? 'positive' : 'negative') : changeType)
    : changeType;
  const isPositive = trendType === 'positive';

  return (
    <div className="stat-card">
      <div className="d-flex justify-content-between align-items-start mb-2">
        <div className={`stat-icon ${iconClass}`}>
          <i className={icon}></i>
        </div>
        {trendValue !== undefined && trendValue !== null && (
          <span className={`badge ${isPositive ? 'badge-success' : 'badge-danger'}`}>
            <i className={`bi bi-arrow-${isPositive ? 'up' : 'down'} me-1`}></i>
            {trendValue}
            {trendLabel ? ` ${trendLabel}` : ''}
          </span>
        )}
      </div>
      <h4 className="stat-value mb-1">{value}</h4>
      <small className="stat-label">{label}</small>
    </div>
  );
};

export default StatCard;
